import { useGetOne } from "#hooks/adapters/adapterUtils";
import {
  TemplatedConfigurationRunAdapter,
  Resources,
} from "@validereinc/domain";
import { HTTPNotFoundError } from "@validereinc/utilities";

/**
 * Return `undefined` data if the dependency graph is not found;
 * this is how we determine if one exists.
 */
const getOneDependencyGraphGracefully = async ({ id }: { id: string }) => {
  try {
    return await TemplatedConfigurationRunAdapter.dependencyGraph.getOne({
      id,
    });
  } catch (error) {
    if (error instanceof HTTPNotFoundError) {
      return { data: undefined };
    }
    throw error;
  }
};

export const useFetchResourceDependencyGraph = useGetOne(
  getOneDependencyGraphGracefully,
  Resources.TEMPLATED_CONFIGURATION_RUN,
  "dependencyGraph"
);
